import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { first } from 'rxjs/operators';
import {
    TenderBidAnalysisReportService
} from "../../services/tender-bid-analysis-report/tender-bid-analysis-report.service";

@Injectable()
export class TenderBidAnalysisReportResolver  {
    constructor(
        private service: TenderBidAnalysisReportService
    ) {
    }

    // @ts-ignore
    public resolve(route: ActivatedRouteSnapshot) {
        return this.service.fetch(route.parent.params.id).pipe(first());
    }
}
